export default __webpack_public_path__ + "static/media/logo_fb.fe3af82f.png";